import { UserProduct } from '@interfaces/auth';
export function uniqueGroupsMap(allGroups: UserProduct[]): UserProduct[] {
  const uniqueGroups = [
    ...new Set(allGroups.map((o) => JSON.stringify(o))),
  ].map((string) => JSON.parse(string));

  return [...uniqueGroups];
}
